// On form Submission send over AJAX request


/**
 * Submit formdata via axios
 * @param formData
 * @returns {Promise}
 */
function submitForm(formData) {
  return axios.post('/', formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
    });
}

function timer(timeout) {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(), timeout);
  });
}

const contactForm = document.querySelector('.contact-form');
const contactLoading = document.querySelector('.contact-loading');
const contactFormButton = document.querySelector('.contact-form-button');
const contactSuccessMessage = document.querySelector('.contact-success');

if (contactForm) {

  document.addEventListener('input', function (event) {
    if (event.target.id === 'versicherung') {
      if (event.target.value === 'privat/Selbstzahler') {
        document.querySelector('.only-private').disabled = false;
        document.getElementById('subject').value = 'Rückrufanfrage - privat/Selbstzahler';
      } else if (event.target.value === 'Berufsgenossenschaft (Arbeitsunfall)') {
        document.getElementById('subject').value = 'Rückrufanfrage - Berufsgenossenschaft (Arbeitsunfall)';
        document.querySelector('.only-private').disabled = true;
      } else {
        document.getElementById('subject').value = 'Rückrufanfrage - gesetzlich';
        document.querySelector('.only-private').disabled = true;
      }
    }
  });


  contactForm.addEventListener('submit', e => {
    e.preventDefault();

    contactForm.classList.add('hidden');

    contactLoading.classList.remove('hidden');
    contactLoading.classList.remove('opacity-0');
    contactLoading.classList.add('opacity-100');

    let formData = new FormData(contactForm);

    Promise.all([submitForm(formData), timer(666)]).then(
      responses => {
        if (responses[0].status === 200) {

          contactLoading.classList.remove('opacity-100');
          contactLoading.classList.add('opacity-0');
          contactLoading.classList.add('hidden');

          contactSuccessMessage.classList.remove('hidden');
          contactSuccessMessage.classList.remove('opacity-0');
          contactSuccessMessage.classList.add('opacity-100');

        } else  {
          alert('Leider hat das Senden ihrer E-Mail nicht funktioniert. Rufen Sie uns am besten an!')

          contactLoading.classList.remove('opacity-100');
          contactLoading.classList.add('opacity-0');
          contactLoading.classList.add('hidden');

          contactForm.classList.remove('hidden');

        }

      }
    );
  });

}

